import React, { useState, useEffect } from "react";
import DynamicBanner from "../../include/DynamicBanner";
import Introduction from "./Partials/Introduction";
import Member from "./Partials/Member"; // Renamed from Composition to match your specific file
import LinkSection from "./Partials/LinkSection";
import StickyNav from "../CommitteeCouncil/Partials/StickyNav";
import api from "../../../../api"; // Ensure this path matches your project structure
import "./Iaec.css";

// fallback base url if env not set
const BASE_URL = process.env.REACT_APP_API_URL;

const Iaec = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Replace with your actual endpoint for IAEC
        const response = await api.get("/api/sitepages/academic/iaec");
        if (response.data.status) {
          setData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Helper to append Base URL
  const getFullUrl = (path) => {
    if (!path) return "";
    return path.startsWith("http") ? path : `${BASE_URL}${path}`;
  };

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (!data) return <div className="text-center py-5">No Data Found</div>;

  // Banner Logic – SUPPORT MULTIPLE IMAGES
  const bannerImage = data.banner_section?.desktop_images?.map(
    (img) => `/${img}`,
  ) || ["/assets/images/default-banner.webp"];

  const bannerImageMobile = data.banner_section?.mobile_images?.map(
    (img) => `/${img}`,
  ) || ["/assets/images/default-banner.webp"];

  const bannerTitle = data.banner_section?.heading || "IAEC";

  return (
    <div className="iaec-section">
      <DynamicBanner
        title={bannerTitle}
        bgImage={bannerImage}
        bgImageMobile={bannerImageMobile}
      />

      <StickyNav tabs={data.introduction_tabs || []} />

      {/* Introduction & Functions Section */}
      <Introduction sectionData={data.section_2} baseUrl={BASE_URL} />

      {/* Member Table Section */}
      <Member sectionData={data.section_3} />

      {/* Accordion Links Section */}
      <LinkSection sectionData={data.section_4} baseUrl={BASE_URL} />
    </div>
  );
};

export default Iaec;
